export const employmentTypes = [
    "Full-Time",
    "Part-Time",
    "Per Diem",
    "Contractor",
    "Temporary",
    "Other",
  ];

export const benefitOptions = [
    "Dental Insurance",
    "Life Insurance",
    "Medical Insurance",
    "Paid Time Off",
    "Retirement",
    "Vision Insurance",
  ];

export const payTypeOptions = ["range", "exact"];

export const currencyOptions = ["USD", "EUR", "CAD"];

export const frequencyOptions = ["annually", "monthly", "weekly", "daily", "hourly"];